import store from '../../../vuex/store'
import { upsertListingDetails } from '../../../listings/repository/listingRepository'
import { getRepresentatives, upsertRepresentatives } from '../repository/propertyRepository.js'

export const deleteProperty = (property) => {
    try {
        store.commit("REMOVE_PROPERTY_BY_MID", property)
    } catch (err) {
        console.log(err)
        return err
    }
}

export const draftProperty = (fromStatus, property) => {
    try {
        let availDetUpdates = property.availDet
        availDetUpdates.status = "draft"
        // update upstream
        upsertListingDetails(property._id, "availDet", availDetUpdates)

        // update locally
        store.dispatch("moveProperty", { fromStatus: fromStatus, property: property })
    } catch (err) {
        console.log(err)
        return err
    }
}

export const archiveProperty = (fromStatus, property) => {
    try {
        let availDetUpdates = property.availDet
        availDetUpdates.status = "archived"

        // update upstream
        upsertListingDetails(property._id, "availDet", availDetUpdates)

        // update locally
        store.dispatch("moveProperty", { fromStatus: fromStatus, property: property })
    } catch (err) {
        console.log(err)
        return err
    }
}

export const upsertPropertyInStorage = (property) => {
    store.commit("UPSERT_PROPERTY", property)
}

export const moveProperty = (fromStatus, property) => {
    store.dispatch("moveProperty", { fromStatus: fromStatus, property: property })
}

export const getPropertyRepresentatives = (propertyId) => {
    return getRepresentatives(propertyId)
}

export const upsertPropertyRepresentatives = (repCommand) => {
    if(repCommand.propertyId) return upsertRepresentatives(repCommand)
}




// WEBPACK FOOTER //
// ./src/platform/properties/services/propertyService.js